/*! facett renewal — Hero MV (Swiper + header overlay sync)
 * 後続セクション追加時の注意は @dev/SYNC_facett-hero.md「凍結・非干渉」を参照
 */
(function () {
  var MQ_PC = window.matchMedia('(min-width: 992px)');

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function setAppearance(value) {
    var appearance = value === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-facett-hero-appearance', appearance);
  }

  function setFadeDuration(ms) {
    var duration = Math.max(0, parseInt(ms, 10) || 600);
    document.documentElement.style.setProperty('--facett-hero-fade-ms', duration + 'ms');
  }

  /* Hero 不在時に html/body グローバル状態を残さない（下層・編集時の崩れ防止） */
  function clearHeroPageState() {
    document.body.classList.remove('facett-has-hero', 'facett-header-solid');
    document.documentElement.removeAttribute('data-facett-hero-appearance');
    document.documentElement.style.removeProperty('--facett-hero-fade-ms');
  }

  function syncHeroPageState() {
    if (!document.querySelector('[data-facett-hero]')) {
      clearHeroPageState();
    }
  }

  function destroyHero(root) {
    if (!root) return;
    if (root._facettProgressRaf) {
      cancelAnimationFrame(root._facettProgressRaf);
      root._facettProgressRaf = null;
    }
    if (root._facettSwiper && typeof root._facettSwiper.destroy === 'function') {
      try {
        root._facettSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
      root._facettSwiper = null;
    }
    root.dataset.facettHeroReady = '';
    /* facettOverlayBound は残す（scroll/resize の二重登録防止） */
  }

  function appearanceFromSlide(slide) {
    if (!slide) return 'light';
    return slide.getAttribute('data-facett-appearance') === 'dark' ? 'dark' : 'light';
  }

  function syncAppearanceFromRoot(root, swiper) {
    var slide = null;
    if (swiper && swiper.slides && swiper.slides.length) {
      slide = swiper.slides[swiper.activeIndex];
    } else {
      slide = root.querySelector('.swiper-slide');
    }
    setAppearance(appearanceFromSlide(slide));
  }

  function updateHeaderSolid(root) {
    if (!MQ_PC.matches || !root || !document.querySelector('[data-facett-hero]')) {
      document.body.classList.remove('facett-header-solid');
      return;
    }
    /* 少しスクロールしたらベタ白へ（潜り込み解除） */
    var solid = (window.pageYOffset || document.documentElement.scrollTop) > 72;
    document.body.classList.toggle('facett-header-solid', solid);
  }

  function bindOverlay(root) {
    if (root.dataset.facettOverlayBound === '1') return;
    root.dataset.facettOverlayBound = '1';

    var onScroll = function () {
      updateHeaderSolid(root);
    };
    var onResize = function () {
      updateHeaderSolid(root);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (MQ_PC.addEventListener) {
      MQ_PC.addEventListener('change', onResize);
    } else if (MQ_PC.addListener) {
      MQ_PC.addListener(onResize);
    }
    updateHeaderSolid(root);
  }

  /* CSS @keyframes で width 0→100%。クラス付け直しでリセット */
  function restartProgress(root, delayMs) {
    var fill = root.querySelector('[data-facett-hero-progress]');
    if (!fill) return;

    var duration = delayMs || 5000;
    fill.classList.remove('is-running');
    fill.style.animation = 'none';
    fill.style.width = '0%';
    fill.style.opacity = '1';
    /* reflow で animation 再適用 */
    void fill.offsetWidth;
    fill.style.animation = '';
    fill.style.animationDuration = duration + 'ms';
    fill.classList.add('is-running');
  }

  function initHero(root) {
    if (!root || root.dataset.facettHeroReady === '1') return;
    var el = root.querySelector('[data-facett-hero-swiper]');
    if (!el) return;

    /* 再初期化時の二重 Swiper 防止 */
    if (root._facettSwiper) {
      destroyHero(root);
    }

    var speed = parseInt(root.dataset.speed, 10) || 600;
    var delay = parseInt(root.dataset.delay, 10) || 5000;
    var slideCount = el.querySelectorAll('.swiper-slide').length;

    bindOverlay(root);
    setFadeDuration(speed);
    syncAppearanceFromRoot(root, null);

    /* プログレスは Swiper 成否に関係なく開始（帯の有無を担保） */
    if (slideCount > 1 && root.querySelector('[data-facett-hero-progress]')) {
      root.classList.remove('facett-hero--single');
      setTimeout(function () {
        restartProgress(root, delay);
      }, 100);
    }

    if (!window.Swiper) {
      root.dataset.facettHeroReady = '1';
      return;
    }

    if (slideCount <= 1) {
      root.classList.add('facett-hero--single');
      root.dataset.facettHeroReady = '1';
      return;
    }

    var paginationEl = root.querySelector('[data-facett-hero-pagination]');
    var progressReady = false;

    var swiper = new window.Swiper(el, {
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: speed,
      /* 縦スクロールと干渉しないようタッチスワイプは無効（自動再生のみ） */
      allowTouchMove: false,
      simulateTouch: false,
      touchStartPreventDefault: false,
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      a11y: {
        enabled: true,
      },
      on: {
        init: function () {
          if (this.el) {
            this.el.style.touchAction = 'pan-y';
          }
          setFadeDuration(speed);
          syncAppearanceFromRoot(root, this);
          root._facettLastIndex = this.realIndex;
          setTimeout(function () {
            progressReady = true;
            restartProgress(root, delay);
          }, 250);
        },
        /* 画像フェード開始と同じ瞬間にヘッダー帯・UIを切替開始 */
        slideChangeTransitionStart: function () {
          syncAppearanceFromRoot(root, this);
        },
        slideChangeTransitionEnd: function () {
          if (!progressReady) return;
          if (this.realIndex === root._facettLastIndex) return;
          root._facettLastIndex = this.realIndex;
          restartProgress(root, delay);
        },
      },
    });

    root._facettSwiper = swiper;
    root.dataset.facettHeroReady = '1';
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-hero]');
    if (!roots.length) {
      clearHeroPageState();
      return;
    }

    document.body.classList.add('facett-has-hero');

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

    /* Swiper 待ち前でもプログレス要素があれば一度動かす */
    roots.forEach(function (root) {
      bindOverlay(root);
      setFadeDuration(root.dataset.speed);
      syncAppearanceFromRoot(root, null);
      var delay = parseInt(root.dataset.delay, 10) || 5000;
      if (root.querySelector('[data-facett-hero-progress]')) {
        restartProgress(root, delay);
      }
    });

    Promise.all([loadStylesheet(cssHref), loadScript(jsSrc)])
      .then(function () {
        roots.forEach(function (root) {
          root.dataset.facettHeroReady = '';
          initHero(root);
        });
      })
      .catch(function () {
        roots.forEach(function (root) {
          root.dataset.facettHeroReady = '1';
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-hero]');
    if (root) {
      destroyHero(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-hero]');
    if (root) {
      destroyHero(root);
    }
    setTimeout(syncHeroPageState, 0);
  });
})();
